// RoundHeaderCell.jsx
import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import ArrowDirectionIcon from "../../../components/ArrowDirectionIcon";
import { tokens } from "../../../theme"; // adjust path as needed

const RoundHeaderCell = ({ roundNumber }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  const isEven = roundNumber % 2 === 0;

  return (
    <div className="cell-container">
      <div className="cell">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            height: { xs: 64, sm: 68, md: 72, lg: 70, xl: 80 },
            //pl: { xs: 0.5, sm: 0.75, md: 1 }, // consistent small indent
            gap: 0.5,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: colors.grey[100],
              fontSize: 14,
              fontWeight: "bold",
              lineHeight: 1,
            }}
          >
            {roundNumber}
          </Typography>
          <Box
            sx={{
              transform: {
                xs: "scale(1)",
                lg: "scale(1)",
                xl: "scale(1)",
              },
            }}
          >
            {isEven ? (
              <ArrowDirectionIcon direction="left" location="round-header" />
            ) : (
              <ArrowDirectionIcon direction="right" location="round-header" />
            )}
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default RoundHeaderCell;
